import React from 'react';
import { CreatePasswordModal } from '@simplybenefits/sb-ui-library';
import { createPassword } from '../../actions/user.js';
import { connect } from "react-redux";

/**
 *
 * @param close
 * @param dispatch
 * @returns {Element}
 * @constructor
 */
function CreatePassword({
    close,
    dispatch
}) {

    /**
     *
     * @param password
     * @returns {Promise<void>}
     */
    const submit = async (password) => {
        const result = await dispatch(createPassword(password));

        if (result) {
            window.location.reload();
        }
    };

    return (
        <CreatePasswordModal
            open={true}
            close={close}
            submit={(...params) => submit(...params)}
        />
    );
}

/**
 *
 * @param state
 * @returns {{loader}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default connect(mapStateToProps)(CreatePassword);